// extracted by mini-css-extract-plugin
export default {"ticketSubmissionContainer":"_ticket-submission_ticketSubmissionContainer__VlDYV","iFrame":"_ticket-submission_iFrame__EJMej"};